"use client";

import Image from "next/image";
import { MainLayout } from "@/components/layout/main-layout";
import { SignUpForm } from "@/components/auth/signup-form";

export default function SignUpPage() {
  return (
    <MainLayout>
      <section className="flex flex-col min-h-screen bg-background">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 flex-1 items-stretch gap-0 px-0 min-h-full">
          
          {/* Left side: Centered and smaller form */}
          <div className="flex flex-col justify-center items-center px-6 py-12 space-y-6">
            <div className="w-full max-w-md space-y-6">
              <div className="flex flex-col space-y-2 text-center">
                <h1 className="text-2xl font-semibold tracking-tight">
                  Create an account
                </h1>
                <p className="text-sm text-muted-foreground">
                  Enter your details below to create your account
                </p>
              </div>
              <SignUpForm />
            </div>
          </div>

          {/* Right side: Full height Image */}
          <div className="relative hidden lg:block w-full h-full">
            <Image
              src="/images/admin.svg"
              alt="Authentication"
              fill
              className="object-cover"
              priority
            />
          </div>
        </div>
      </section>
    </MainLayout>
  );
}